import {Base64} from 'js-base64'

export default {
  methods: {
    base64Encode (str) {
      const base64 = Base64.encode(str)
      return base64.replace(/\+/g, '-').replace(/\//g, '_')
    },
    base64Decode (str) {
      return Base64.decode(str)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/base64.js